<template>
    <div class="field-time" v-bind:class="{ 'field-time--fallback': !inputTimeCanBeUsed }">
        <label v-if="label" class="field-time__label"
            >{{ label }}<span v-if="required" class="field-time__req">&nbsp;*</span></label
        >
        <div class="field-time__input-wrap">
            <template v-if="inputTimeCanBeUsed">
                <input
                    type="time"
                    v-model="simpleFieldModel"
                    :disabled="checkDisabled"
                    :required="required"
                    class="field-time__input"
                />
            </template>
            <template v-else>
                <select :value="getTimeHours" @input="setTimeHours">
                    <option value="">--</option>
                    <option v-for="n in 24" v-bind:key="n">{{ pad(n - 1, 2) }}</option>
                </select>
                <span class="field-time__fallback-colon">:</span>
                <select :value="getTimeMinutes" @input="setTimeMinutes">
                    <option value="">--</option>
                    <option v-for="n in 60" v-bind:key="n">{{ pad(n - 1, 2) }}</option>
                </select>
            </template>
        </div>
        <button
            :disabled="increaseButtonDisabled"
            @click.prevent="inc"
            href="#"
            class="field-time__button field-time__button--plus"
        >
            +
        </button>
        <button
            :disabled="decreaseButtonDisabled"
            @click.prevent="dec"
            href="#"
            class="field-time__button field-time__button--minus"
        >
            -
        </button>
    </div>
</template>

<script>
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';

export default {
    components: {},
    computed: {
        getTimeHours() {
            return this.getTimePart(0);
        },
        getTimeMinutes() {
            return this.getTimePart(1);
        },
        inputTimeCanBeUsed() {
            let type = 'time';
            let input = document.createElement('input');
            input.setAttribute('type', type);
            return input.type == type;
        },
        increaseButtonDisabled() {
            if (parseInt(this.getTimeHours) >= 23) {
                return true;
            }
            return false;
        },
        decreaseButtonDisabled() {
            if (
                parseInt(this.getTimeHours) <= 0 ||
                (parseInt(this.getTimeHours) === 0 && parseInt(this.getTimeMinutes) === 0)
            ) {
                return true;
            }
            return false;
        }
    },
    methods: {
        getTimePart(n) {
            let val = this.simpleFieldGet;
            if (val === undefined || val === null || val.indexOf(':') === -1) {
                return '';
            }
            return val.split(':')[n];
        },
        async setTimeHours(e) {
            await this.setTimePart(e.target.value, 0);
        },
        async setTimeMinutes(e) {
            await this.setTimePart(e.target.value, 1);
        },
        async setTimePart(value, n) {
            value = this.pad(value, 2);
            if (n === 0) {
                value = value + ':' + this.getTimePart(1);
            } else if (n === 1) {
                value = this.getTimePart(0) + ':' + value;
            }
            await this.simpleFieldSet(value);
        },
        async inc() {
            await this.reset();
            await this.setTimePart(parseInt(this.getTimeHours) + 1, 0);
        },
        async dec() {
            await this.reset();
            await this.setTimePart(parseInt(this.getTimeHours || 12) - 1, 0);
        },
        async reset() {
            if (this.getTimeHours == '') {
                await this.setTimePart('12', 0);
            }
            if (this.getTimeMinutes == '') {
                await this.setTimePart('0', 1);
            }
        },
        pad(num, size) {
            let s = num + '';
            while (s.length < size) {
                s = '0' + s;
            }
            return s;
        }
    },
    props: {},
    mixins: [SimpleFieldMixin]
};
</script>
